(function($) {
    $(function() {
        function getCookieHack(name) {
            if (typeof window.cookiedone !== 'undefined') {
                return window.cookiedone.getCookie(name);
            }
            var item = window.localStorage.getItem(name);
            if (item) {
                return item;
            }
            return undefined;
        }

        $('.js-open-cookie').click(function(e) {
            e.preventDefault();
            window.cookiedone.showCookieSettings();
        });

        $(document).on('click', '#done-gdpr-save-button', function(e) {
            cookieSetup();
        });

        $(document).on('click', '.done-gdpr-button-allow', function(e) {
            e.preventDefault();
            e.stopPropagation();
            window.cookiedone.allowAll();
            cookieSetup();
        });

        function cookieSetup() {
            window.dataLayer = window.dataLayer || [];
            $.cookieSettings = getCookieHack('DONEGDPRConsent');
            if ($.cookieSettings != undefined) {
                $.cookieSettings = JSON.parse($.cookieSettings);
            }

            if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
                window['ga-disable-G-CEK123SXC3'] = false;

                dataLayer.push({ cookie_performance: 'enable' });

                function gtag() {
                    dataLayer.push(arguments);
                }

                gtag('js', new Date());
                gtag('config', 'G-CEK123SXC3');
            } else {
                window['ga-disable-G-CEK123SXC3'] = true;

                dataLayer.push({ cookie_performance: 'disabled' });

                var cookies = Cookies.get();
                var cookies_to_disable = ['_ga', '_ga_CEK123SXC3'];

                if ('' !== cookies) {
                    $.each(cookies, function(index) {
                        index = '' + index;
                        if ($.inArray(index, cookies_to_disable) != -1) {
                            Cookies.remove(index, { domain: document.domain });
                        }
                    });
                }
            }
        }

        cookieSetup();
    });
})(jQuery);
